import React from "react";
import Container from "../../../../../layouts/containers/Container";
import "./aapointmentreport.scss";
function Appointments() {
  return (
    <Container className="appointment-report">
      <div className="header">Treatments List</div>
      <table>
        <thead>
          <tr>
            <th>REG NUMBER</th>
            <th>PATIENT NAME</th>
            <th>STATUS</th>
            <th>DATE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>name</td>
            <td>name</td>
            <td>name</td>
            <td>name</td> 
          </tr>
        </tbody>
      </table>
    </Container>
  );
}

export default Appointments;
